import { Token, TokenInterface } from 'app/core/authentication/models/token.model';
import { Error } from 'app/core/error-handler/models';
import { User, UserInterface } from 'app/core/user/models';
import * as jwtDecode from 'jwt-decode';

import { AuthActions, AuthActionType } from './actions';
import { AuthState } from './models';

const initialState: AuthState = new AuthState({
  isLicensed: undefined,
  resetTokenValidated: undefined,
  jwt: undefined,
  token: undefined,
  error: undefined,
  authenticatedUser: undefined,
});

export function authReducer(
  state: AuthState = initialState,
  action: AuthActions): AuthState {
  switch (action.type) {
    case AuthActionType.LicenseCheck:
    case AuthActionType.Login:
    case AuthActionType.PasswordReset:
    case AuthActionType.PasswordResetSent:

      return {
        ...state,
        jwt: undefined,
        token: undefined,
        error: undefined,
        authenticatedUser: undefined,
      };

    case AuthActionType.PasswordResetTokenInvalid:
    case AuthActionType.PasswordResetFailed:

      return {
        ...state,
        resetTokenValidated: false,
      };

    case AuthActionType.LicenseCheckCompleted:

      return {
        ...state,
        isLicensed: true,
      };

    case AuthActionType.LicenseCheckFailed:

      return {
        ...state,
        isLicensed: false,
      };

    case AuthActionType.LoginFailed:

      const error: Error = action.payload as Error;
      return {
        ...state,
        error,
        jwt: undefined,
        token: undefined,
        authenticatedUser: undefined,
      };

    case AuthActionType.LoginCompleted:
    case AuthActionType.LoadTokenCompleted:
    case AuthActionType.PasswordResetTokenValid:

      const jwt: string = action.payload as string;
      if (!jwt) {
        return {
          ...state,
          jwt,
          error: undefined,
        };
      }

      let decodedJwt: any;
      try {
        decodedJwt = jwtDecode(jwt);
      } catch (e) {
        return {
          ...state,
          jwt: undefined,
          error: e as Error,
        };
      }

      const decodedUser: any = JSON.parse(decodedJwt.user);
      const authenticatedUser: UserInterface = new User(decodedUser);
      const token: TokenInterface = new Token({
        exp: decodedJwt.exp,
        scopes: JSON.parse(decodedJwt.scopes),
        loggedInUser: authenticatedUser,
      });

      return {
        ...state,
        jwt,
        token,
        authenticatedUser,
        resetTokenValidated: true,
        error: undefined,
      };


    default:
      return state;
  }
}
